import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import type { DtfPricingRequest, DtfArtworkPricing } from "./types";

type FetchDtfPricingParams = {
  transferTypeId: string;
  artworks: Array<{
    artworkId: string;
    width: number;
    height: number;
    quantity: number;
    enhancementTier: string;
    hasExpertEditAddon?: boolean;
  }>;
};

/**
 * Fetches DTF pricing for one or more transfer size configurations
 * Returns a map of artworkId to pricing data
 */
export async function fetchDtfPricing(
  params: FetchDtfPricingParams
): Promise<Record<string, DtfArtworkPricing> | null> {
  const { transferTypeId, artworks } = params;

  if (artworks.length === 0) {
    return {};
  }

  try {
    const request: DtfPricingRequest = {
      artworks: artworks.map(artwork => ({
        artwork_id: artwork.artworkId,
        width: artwork.width,
        height: artwork.height,
        quantity: artwork.quantity,
        enhancement_tier: artwork.enhancementTier,
        has_expert_edit_addon: artwork.hasExpertEditAddon || false
      })),
      pre_cut: false
    };

    const response = await api.dtf.dtfPricing(
      { product: transferTypeId }, // Transfer type ID is used as product ID
      request
    );

    // Convert entire response to camelCase
    const pricingData = objNamesToCamelCase(response) as {
      artworks?: Record<string, DtfArtworkPricing>;
    };

    if (pricingData?.artworks) {
      return pricingData.artworks;
    }

    return null;
  } catch {
    // Silently fail and return null - the UI will handle the missing pricing
    return null;
  }
}
